<template>
  <div>
    <div class="list-box">
      <table>
        <thead>
          <tr>
            <th>RSVP ID</th>
            <th>Created</th>
            <th>Discount Amount</th>
            <!-- <th></th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, i) in list" :key="i">
            <td>
              <a :href="`#/reservation/${data.rsvpId}`" target="_blank">{{data.rsvpId}}</a>
            </td>
            <td>{{data.created}}</td>
            <td>${{Math.abs(data.amount)}}</td>
            <!-- <td>{{data.type}}</td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <!-- <div class="fix-footer">
      <div class="row">
        <div class="small-3 columns per-page">
          <span>Displaying</span>
          <select v-model="perPage" :disabled="loading">
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          <span>per page</span>
        </div>

        <div class="small-6 columns page-data">
          <span v-show="list.length > 0">
            Displaying
            <b>{{ pageData.start }}</b> - <b>{{ pageData.end }}</b> of
            <b>{{ pageData.max }}</b>
          </span>
        </div>

        <div class="small-3 columns pagination">
          <span>Page</span>
          <span :class="{'prevNext':true, 'disabled':currentPage === 1 || loading}" @click="prev">
            <i class="fas fa-chevron-left"></i>
          </span>
          <select v-model="currentPage" :disabled="loading">
            <option v-for="i in totalPage" :value="i" :key="i">{{i}}</option>
          </select>
          <span :class="{'prevNext':true, 'disabled':isLastPage || loading}" @click="next">
            <i class="fas fa-chevron-right"></i>
          </span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'discount-code-list',
  data () {
    return {
      // loading: false,
      list: [],
      // currentPage: 1,
      // perPage: 20
    }
  },
  computed: {
    id () { return this.$route.params.id },
    discountCodes () { return this.$store.state.discountCodes },
    view () { return this.discountCodes.view }
    // pageData () {
    //   let tableData = this.$store.state.promo.view
    //   let start = (this.currentPage * this.perPage) - (this.perPage - 1)
    //   let end = this.currentPage * this.perPage
    //   return {
    //     start: start < 1 ? 1 : start,
    //     end: end > tableData.maxList ? tableData.maxList : end,
    //     max: tableData.maxList
    //   }
    // },
  },
  methods: {
    getList () {
      let self = this
      if (self.view.loading) return

      self.view.loading = true
      self.$sdk.get(`/discountcode/${self.id}/usage`, {
        token: self.$store.state.session.sessionToken,
      }, res => {
        self.view.loading = false
        if (res.error) {
          self.list = []
          return
        }
        self.list = []
        res.list.forEach(rsvp => {
          self.list.push({
            rsvpId: rsvp.rsvpId,
            created: moment(rsvp.created, 'X').format('MM/DD/YYYY hh:mmA'),
            amount: rsvp.discountAmount.toFixed(2),
            type: rsvp.useType
          })
        })
        self.$store.commit('discountCodes/setViewData', {list: self.list})
      })
    }
  },
  mounted () {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.list-box{
  overflow-y: auto;
  height: calc(100vh - 50px);

  thead {
    color: #8DA0A9;
    font-size: 12px;

    th {
      border-bottom: 1px solid #ccc;
      background-color: #f5f5f5;
      position: sticky;
      top: 0px;
    }
  }
}
table {
  border-collapse: collapse;
  width: 100%;
}
th, td {
  padding: 5px;
  text-align: center;
}
tr{
  border-bottom: 1px solid #ddd;

  &:nth-child(even){
    background: #fbfbfb;
  }
  td{
    font-size: 14px;
    padding: 8px 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DiscountCodes/RsvpList.vue